function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import ListEndorsement from "./ListEndorsement";
import SearchInputs from "./SearchInputs";
import { componentIds } from "./utils";
import { ReactiveBase, ReactiveList } from "@appbaseio/reactivesearch";

var GeneralListEndorsements = function GeneralListEndorsements(props) {
  var endorsement_types = props.endorsement_types;

  var _React$useState = React.useState("updated_at"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      sortField = _React$useState2[0],
      setSortField = _React$useState2[1];

  var _React$useState3 = React.useState("desc"),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      sortOrder = _React$useState4[0],
      setSortOrder = _React$useState4[1];

  var scrollPositionRef = React.useRef(0);

  var handleSort = function handleSort(field) {
    // Guardar la posición actual del scroll
    scrollPositionRef.current = window.pageYOffset || document.documentElement.scrollTop || window.scrollY;

    if (sortField === field) {
      // Si es el mismo campo, alternar entre asc y desc
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Si es un campo diferente, establecerlo y empezar con desc
      setSortField(field);
      setSortOrder("desc");
    }
  }; // Efecto para restaurar el scroll después de que se actualice el componente


  React.useEffect(function () {
    if (scrollPositionRef.current > 0) {
      // Usar múltiples intentos para asegurar que el scroll se restaure
      var restoreScroll = function restoreScroll() {
        window.scrollTo({
          top: scrollPositionRef.current,
          behavior: 'auto' // Sin animación para que sea instantáneo

        });
      }; // Intentar restaurar inmediatamente


      restoreScroll(); // Intentar de nuevo después de que React haya actualizado el DOM

      requestAnimationFrame(function () {
        restoreScroll(); // Un intento más después de un pequeño delay para asegurar

        setTimeout(function () {
          restoreScroll();
        }, 50);
      });
    }
  }, [sortField, sortOrder]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ReactiveBase, {
    app: "poliza_endorsements",
    url: "".concat(process.env.SEGUROS_API_URL),
    headers: {}
  }, /*#__PURE__*/React.createElement("aside", null, /*#__PURE__*/React.createElement(SearchInputs, null)), /*#__PURE__*/React.createElement(ReactiveList, {
    componentId: "EndorsementList" //highlight
    ,
    dataField: sortField,
    pagination: true,
    size: 50,
    loader: "Cargando resultados...",
    sortBy: sortOrder,
    showResultStats: true,
    react: {
      and: componentIds()
    },
    render: function render(_ref) {
      var data = _ref.data;
      return /*#__PURE__*/React.createElement(ReactiveList.ResultListWrapper, {
        style: {
          overflow: "auto"
        }
      }, /*#__PURE__*/React.createElement(ListEndorsement, {
        endorsements: data,
        endorsement_types: endorsement_types,
        sortField: sortField,
        sortOrder: sortOrder,
        onSort: handleSort
      }));
    }
  })));
};

export default GeneralListEndorsements;